import { useMemo } from 'react';

import type { TUIElement } from '@ballerine/common';

import { useDocumentsService } from '@/components/organisms/Form/DocumentsService/hooks/internal/useDocumentsService';
import { useDynamicForm } from '../../../context';
import { buildValidationSchemaFromFormElements } from '../../../helpers/build-validation-schema-from-form-elements';

export const useValidationSchema = (elements: TUIElement[]) => {
  const { metadata } = useDynamicForm();
  const { documents } = useDocumentsService();

  const validationSchema = useMemo(
    () => buildValidationSchemaFromFormElements(elements, [], undefined),
    [elements, documents, metadata],
  );

  return validationSchema;
};
